"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = require("axios");
exports.handlePostAuth = (IDMbaseUrl, provider, state, code, token) => __awaiter(void 0, void 0, void 0, function* () {
    const url = IDMbaseUrl + '/openidm/identityProviders?_action=handlePostAuth';
    const method = 'post';
    const headers = {
        "X-OpenIDM-Username": "anonymous",
        "X-OpenIDM-Password": "anonymous",
        "X-OpenIDM-DataStoreToken": token
    };
    const googleData = {
        "state": [state],
        "code": [code],
        "scope": ["email+profile+https://www.googleapis.com/auth/userinfo.profile+https://www.googleapis.com/auth/userinfo.email+openid"],
        "authuser": ["0"],
        "prompt": ["none"]
    };
    const facebookData = {
        "state": [state],
        "code": [code]
    };
    let data = {};
    if (provider === 'google') {
        data = googleData;
    }
    else if (provider === 'facebook') {
        data = facebookData;
    }
    return yield axios_1.default({
        method,
        url,
        headers,
        data
    })
        .then((resp) => {
        return {
            response: resp.data,
            status: resp.status
        };
    })
        .catch((err) => {
        return {
            error: err
        };
    });
});
exports.attemptSocialAuthLogin = (IDMBaseUrl, token) => __awaiter(void 0, void 0, void 0, function* () {
    const url = IDMBaseUrl + "/openidm/authentication?_action=login";
    const headers = {
        "X-OpenIDM-OAuth-Login": true,
        "X-OpenIDM-DataStoreToken": token
    };
    return yield axios_1.default({
        method: 'post',
        url: url,
        headers: headers,
    })
        .then((resp) => {
        return {
            response: resp.data,
            status: resp.status
        };
    })
        .catch((err) => {
        return {
            error: err
        };
    });
});
exports.startRegistration = (IDMBaseUrl, dataStoreToken, previousDataStoreToken) => __awaiter(void 0, void 0, void 0, function* () {
    // Submit Requirements Process, up through the validateUserProfile stage of allInOneRegistration
    const validateUserProfileResponse = yield selfServiceRegistration(IDMBaseUrl, dataStoreToken);
    return validateUserProfileResponse;
});
exports.socialUserClaimSubmitInitial = (IDMBaseUrl) => __awaiter(void 0, void 0, void 0, function* () {
    const url = IDMBaseUrl + "/openidm/selfservice/socialUserClaim?_action=submitRequirements";
    const headers = {
        "X-OpenIDM-Username": "anonymous",
        "X-OpenIDM-Password": "anonymous",
    };
    const initialDataPayload = {
        "input": {
            "user": {
                "mail": "",
                "password": ""
            }
        }
    };
    return yield axios_1.default({
        method: 'post',
        url: url,
        headers: headers,
        data: initialDataPayload
    })
        .then((resp) => {
        return {
            response: resp.data,
            status: resp.status
        };
    })
        .catch((err) => {
        return {
            error: err
        };
    });
});
exports.socialUserClaimSubmitWithTokens = (IDMBaseUrl, dataStoreToken, processToken) => __awaiter(void 0, void 0, void 0, function* () {
    const url = IDMBaseUrl + "/openidm/selfservice/socialUserClaim?_action=submitRequirements";
    const headers = {
        "X-OpenIDM-Username": "anonymous",
        "X-OpenIDM-Password": "anonymous",
    };
    const data = {
        "input": {
            "clientToken": dataStoreToken
        },
        "token": processToken
    };
    return yield axios_1.default({
        method: 'post',
        url,
        headers,
        data
    })
        .then((resp) => {
        return {
            response: resp.data,
            status: resp.status
        };
    })
        .catch((err) => {
        return {
            error: err
        };
    });
});
const selfServiceRegistration = (IDMBaseUrl, dataStoreToken) => __awaiter(void 0, void 0, void 0, function* () {
    const url = IDMBaseUrl + "/openidm/selfservice/registration?_action=submitRequirements";
    const headers = {
        "X-OpenIDM-Username": "anonymous",
        "X-OpenIDM-Password": "anonymous"
    };
    const initialRequestPayload = { "input": { "input": {} } };
    return yield axios_1.default({
        method: 'post',
        url: url,
        headers: headers,
        data: initialRequestPayload
    })
        .then((resp) => {
        return handleInitialRegSuccess(IDMBaseUrl, resp, dataStoreToken);
    })
        .catch((err) => {
        return {
            error: err
        };
    });
});
const handleInitialRegSuccess = (IDMBaseUrl, resp, dataStoreToken) => __awaiter(void 0, void 0, void 0, function* () {
    if (resp.data.token) {
        // Do the axios call to get the validateUserProfile payload
        return yield axios_1.default({
            url: IDMBaseUrl + "/openidm/selfservice/registration?_action=submitRequirements",
            method: 'post',
            headers: {
                "X-OpenIDM-Username": "anonymous",
                "X-OpenIDM-Password": "anonymous"
            },
            data: {
                "input": {
                    "clientToken": dataStoreToken,
                    "oauthRegister": "true"
                },
                "token": resp.data.token
            }
        })
            .then((resp) => {
            return {
                response: resp
            };
        })
            .catch((err) => {
            return {
                error: err
            };
        });
    }
    else {
        return {
            error: "No token existed in. Can't proceed with the successful response from the initial registration request."
        };
    }
});
exports.validateObject = (IDMBaseUrl, mail, phone) => __awaiter(void 0, void 0, void 0, function* () {
    const url = IDMBaseUrl + "/openidm/policy/selfservice/registration?_action=validateObject";
    const headers = {
        "X-OpenIDM-Username": "anonymous",
        "X-OpenIDM-Password": "anonymous"
    };
    var data = {};
    if (phone != null && mail === null) {
        data = {
            "user": {
                "telephoneNumber": phone
            }
        };
    }
    else if (phone === null && mail != null) {
        data = {
            "user": {
                "mail": mail
            }
        };
    }
    else {
        data = {
            "user": {
                "mail": mail,
                "telephoneNumber": phone
            }
        };
    }
    return yield axios_1.default({
        url: url,
        headers: headers,
        data: data,
        method: 'post'
    })
        .then((resp) => {
        var isEmailAvailable = true;
        var isPhoneAvailable = true;
        for (var i in resp.data.failedPolicyRequirements) {
            if (resp.data.failedPolicyRequirements[i].property === "/user/mail" && mail != null) {
                isEmailAvailable = false;
            }
            else if (resp.data.failedPolicyRequirements[i].property === "/user/telephoneNumber" && phone != null) {
                isPhoneAvailable = false;
            }
        }
        return {
            response: resp,
            isEmailAvailable: isEmailAvailable,
            isPhoneAvailable: isPhoneAvailable
        };
    })
        .catch((err) => {
        return {
            error: err
        };
    });
});
// Checks if email is valid
exports.validateEmail = (IDMBaseUrl, email) => __awaiter(void 0, void 0, void 0, function* () {
    const url = IDMBaseUrl + "/openidm/policy/selfservice/registration?_action=validateObject";
    const headers = {
        "X-OpenIDM-Username": "anonymous",
        "X-OpenIDM-Password": "anonymous"
    };
    const data = {
        "user": {
            "mail": email
        }
    };
    return yield axios_1.default({
        url: url,
        headers: headers,
        data: data,
        method: 'post'
    })
        .then((resp) => {
        return {
            response: resp,
            email: email
        };
    })
        .catch((err) => {
        return {
            error: err
        };
    });
});
// Checks if phone number is valid
exports.validatePhoneNumber = (IDMBaseUrl, phone) => __awaiter(void 0, void 0, void 0, function* () {
    const url = IDMBaseUrl + "/openidm/policy/selfservice/registration?_action=validateObject";
    const headers = {
        "X-OpenIDM-Username": "anonymous",
        "X-OpenIDM-Password": "anonymous"
    };
    const data = {
        "user": {
            "telephoneNumber": phone.replace(/[^\d]/g, '').length > 10 ? phone.replace(/[^\d]/g, '').substring(1) : phone.replace(/[^\d]/g, '')
        }
    };
    return yield axios_1.default({
        url: url,
        headers: headers,
        data: data,
        method: 'post'
    })
        .then((resp) => {
        return {
            response: resp,
            mobileNumber: phone.replace(/[^\d]/g, '').length > 10 ? phone.replace(/[^\d]/g, '').substring(1) : phone.replace(/[^\d]/g, '')
        };
    })
        .catch((err) => {
        return {
            error: err
        };
    });
});
exports.finishRegistration = (IDMBaseUrl, givenName, sn, mail, phone, provider, brand, token) => __awaiter(void 0, void 0, void 0, function* () {
    const adjustedPhone = phone.replace(/[^\d]/g, '').length > 10 ? phone.replace(/[^\d]/g, '').substring(1) : phone.replace(/[^\d]/g, '');
    const url = IDMBaseUrl + "/openidm/selfservice/registration?_action=submitRequirements";
    const headers = {
        "X-OpenIDM-Username": "anonymous",
        "X-OpenIDM-Password": "anonymous"
    };
    const data = {
        "input": {
            "user": {
                "givenName": givenName,
                "sn": sn,
                "mail": mail,
                "telephoneNumber": adjustedPhone,
                "userName": mail,
                "preferences": {},
                "brand": brand,
                "i18n": "en-US",
                "ui_locales": "en",
                "market_locale": "US",
                "region": "US",
                "provider": provider,
                "oauth_state": null,
                "oauth_client_id": null,
                "oauth_redirect_uri": null,
                "oauth_nonce": null,
                "oauth_response_type": null,
                "oauth_code_challenge_method": null,
                "oauth_scope": null,
                "oauth_code_challenge": null
            }
        },
        "token": token
    };
    return yield axios_1.default({
        url: url,
        headers: headers,
        data: data,
        method: 'post'
    })
        .then((resp) => {
        return {
            response: resp
        };
    })
        .catch((err) => {
        return {
            error: err
        };
    });
});
exports.userDataProfileIncomplete = (validateUserProfileResponse) => {
    const requiredFields = validateUserProfileResponse.requirements.registrationProperties.required;
    const filledOutFields = validateUserProfileResponse.requirements.properties.user.default;
    // If there is a key in the required fields that is not in the filled in fields we know that the profile is incomplete - default to the payload being good.
    let result = false;
    requiredFields.forEach((req) => {
        if (!Object.keys(filledOutFields).includes(req)) {
            result = true;
        }
    });
    return result;
};
exports.getAuthRedirect = (IDMBaseUrl, baseUrl, brand, provider) => __awaiter(void 0, void 0, void 0, function* () {
    yield logout(IDMBaseUrl);
    let brandProvider = "";
    if (provider === "google") {
        brandProvider = brand === "L" ? "googleLexus" : "googleToyota";
    }
    else if (provider === "facebook") {
        brandProvider = brand === "L" ? "facebookLexus" : "facebookToyota";
    }
    const url = IDMBaseUrl + '/openidm/identityProviders?_action=getAuthRedirect';
    const headers = {
        'X-OpenIDM-Password': 'anonymous',
        'X-OpenIDM-Username': 'anonymous',
        'Content-Type': 'application/json'
    };
    const data = {
        'provider': brandProvider,
        // 'landingPage': IDMBaseUrl + '/#/login?_oauthReturn=true&provider=' + brandProvider + '&gotoURL=%23'
        'landingPage': baseUrl + '/register/google?provider=' + brandProvider + '&gotoURL=%23'
    };
    return yield axios_1.default({
        headers,
        method: 'post',
        url,
        data
    }).then(response => {
        return {
            response: response.data,
            status: response.status
        };
    }).catch(err => {
        return {
            error: err
        };
    });
});
const logout = (IDMBaseUrl) => __awaiter(void 0, void 0, void 0, function* () {
    axios_1.default({
        url: IDMBaseUrl + '/openidm/authentication?_action=logout',
        headers: {
            'X-OpenIDM-Password': 'anonymous',
            'X-OpenIDM-Username': 'anonymous',
            'Content-Type': 'application/json'
        },
        method: 'post'
    })
        .then((resp) => console.log(resp))
        .catch((err) => console.log(err));
});
